import { Node, mergeAttributes } from '@tiptap/core';
import { ManagedFragmentDto } from '../../general/dtos';
import { precedingFragments } from '../content-viewer/fragment-answers';

export const FragmentAnswersNode = Node.create({
    name: 'fragmentAnswers',
    group: 'block',
    atom: true,
    addOptions() {
        return { getContext: () => ({ fragments: [] as ManagedFragmentDto[], currentKey: null as string | null }) };
    },
    addAttributes() { return { 'fragment-key': { default: null } }; },
    parseHTML() { return [{ tag: 'fragment-answers' }]; },
    renderHTML({ HTMLAttributes }) { return ['fragment-answers', mergeAttributes(HTMLAttributes)]; },
    addNodeView() {
        return ({ node, editor, view, getPos }) => {
            const doc = view.dom.ownerDocument;
            const dom = doc.createElement('div');
            dom.contentEditable = 'false';
            dom.className = 'fragment-answers-placeholder';
            dom.style.cssText = 'padding: 1rem; border: 1px dashed currentColor; margin: 0.5rem 0;';
            const label = doc.createElement('label');
            label.textContent = 'Answers table — source fragment: ';
            const select = doc.createElement('select');
            select.setAttribute('aria-label', 'Answers table source fragment');
            label.appendChild(select);
            dom.appendChild(label);
            let currentNode = node;
            const render = () => {
                const context = this.options.getContext();
                const sources = precedingFragments(context.fragments, context.currentKey);
                select.replaceChildren();
                const blank = doc.createElement('option');
                blank.value = '';
                blank.textContent = sources.some(source => source.key === currentNode.attrs['fragment-key'])
                    ? 'Select source fragment' : 'Select a preceding fragment';
                select.appendChild(blank);
                sources.forEach(source => {
                    const option = doc.createElement('option');
                    option.value = source.key;
                    option.textContent = source.title;
                    select.appendChild(option);
                });
                select.value = currentNode.attrs['fragment-key'] ?? '';
            };
            select.addEventListener('change', () => {
                const pos = getPos();
                if (typeof pos === 'number') editor.view.dispatch(editor.state.tr.setNodeMarkup(pos, undefined,
                    { ...currentNode.attrs, 'fragment-key': select.value || null }));
            });
            const refresh = () => render();
            editor.on('transaction', refresh);
            render();
            return {
                dom,
                update(next) {
                    if (next.type !== currentNode.type) return false;
                    currentNode = next;
                    render();
                    return true;
                },
                stopEvent: event => select.contains(event.target as globalThis.Node),
                ignoreMutation: () => true,
                destroy: () => editor.off('transaction', refresh),
            };
        };
    },
});
